import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, " Contraseña ", -1)
const _hoisted_2 = {
  key: 0,
  class: "mb-2 text-caption font-weight-light"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-2 text-caption font-weight-light"
}

import { AuthService, CreateUserForm, SystemUser, UpdateUser } from '@/services/auth/authService';
import { PropType, ref, watch, defineModel, computed } from 'vue';
import { useToast } from 'vue-toast-notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserFormDialog',
  props: /*#__PURE__*/_mergeModels({
    user: {
        type: Object as PropType<SystemUser>,
        required: false
    },
}, {
    "modelValue": { type: Boolean, ...{default: false} },
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["update:user", "create:user", "cancel"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const props = __props;

const authService = new AuthService();
const toast = useToast();
const showDialog = _useModel<boolean>(__props, "modelValue");
const valid = ref(false);

const userForm = ref<UpdateUser>({
    id: props.user?.id,
    name: props.user?.name || "",
    username: props.user?.username || "",
    isAdmin: props.user?.isAdmin || false,
    disabled: props.user?.disabled || false,
});

const emit = __emit;

const isUpdating = computed(() => {
    return !!props.user;
})

const isCreating = computed(() => {
    return !props.user;
})

const passwordRules = computed(() => {
    if (isCreating.value) {
        return [
            (v: string) => !!v || 'La contraseña es obligatoria',
            (v: string) => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres',
        ]
    }
    return []
})

const confirmPasswordRules = computed(() => {
    if (isCreating.value) {
        return [
            (v: string) => !!v || 'La contraseña es obligatoria',
            (v: string) => v === userForm.value.password || 'Las contraseñas no coinciden',
        ]
    }
    else if (isUpdating.value && userForm.value.password) {
        return [
            (v: string) => !!v || 'La contraseña es obligatoria',
            (v: string) => v === userForm.value.password || 'Las contraseñas no coinciden',
        ]
    }
    return []
})

async function save() {
    if (props.user) {
        const updateForm: UpdateUser = {
            id: userForm.value.id,
            name: userForm.value.name,
            username: userForm.value.username,
            isAdmin: userForm.value.isAdmin,
            disabled: userForm.value.disabled,
            password: userForm.value.password,
            confirmPassword: userForm.value.confirmPassword,
        }

        const response = await authService.updateUser(updateForm)

        if (response) {
            emit("update:user", response);
            showDialog.value = false;
            toast.success("Usuario actualizado correctamente", {
                position: "top-right",
                duration: 3000,
            });
            return
        }
    }


    else {
        if (!userForm.value.password || !userForm.value.confirmPassword) {
            return;
        }

        const createForm: CreateUserForm = {
            name: userForm.value.name,
            username: userForm.value.username,
            isAdmin: userForm.value.isAdmin,
            disabled: userForm.value.disabled,
            password: userForm.value.password,
            confirmPassword: userForm.value.confirmPassword,
        }

        const response = await authService.createUser(createForm)

        if (response) {
            emit("create:user", response);
            showDialog.value = false;
            toast.success("Usuario creado correctamente", {
                position: "top-right",
                duration: 3000,
            });
            return
        }
    }

    toast.error("Error al guardar el usuario", {
        position: "top-right",
        duration: 3000,
    });
}

function cancel() {
    showDialog.value = false;
}

watch(showDialog, (newValue) => {
    if (newValue) {
        userForm.value = {
            id: props.user?.id,
            name: props.user?.name || "",
            username: props.user?.username || "",
            isAdmin: props.user?.isAdmin || false,
            disabled: props.user?.disabled || false,
        };
    }
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showDialog).value = $event)),
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.user ? "Editar usuario" : "Nuevo usuario"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref: "form",
                modelValue: valid.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((valid).value = $event)),
                "validate-on": "input"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: userForm.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userForm.value.name) = $event)),
                    label: "Nombre",
                    variant: "outlined",
                    density: "compact",
                    required: "",
                    rules: [(v) => !!v || 'El nombre es obligatorio']
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_text_field, {
                    modelValue: userForm.value.username,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userForm.value.username) = $event)),
                    label: "Username",
                    variant: "outlined",
                    density: "compact",
                    required: "",
                    rules: [(v) => !!v || 'El username es obligatorio']
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_component_v_checkbox, {
                    modelValue: userForm.value.isAdmin,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userForm.value.isAdmin) = $event)),
                    label: "Es administrador",
                    density: "compact",
                    "hide-details": ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_checkbox, {
                    modelValue: userForm.value.disabled,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userForm.value.disabled) = $event)),
                    label: "Deshabilitado",
                    density: "compact"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_divider, { class: "mb-4" }),
                  _createElementVNode("div", null, [
                    _hoisted_1,
                    (isUpdating.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Si no desea cambiar la contraseña, deje los campos vacíos. "))
                      : _createCommentVNode("", true),
                    (isCreating.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " La contraseña es obligatoria. "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_text_field, {
                      modelValue: userForm.value.password,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userForm.value.password) = $event)),
                      label: "Contraseña",
                      variant: "outlined",
                      density: "compact",
                      type: "password",
                      rules: passwordRules.value
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: userForm.value.confirmPassword,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userForm.value.confirmPassword) = $event)),
                      label: "Confirmar contraseña",
                      variant: "outlined",
                      density: "compact",
                      type: "password",
                      rules: confirmPasswordRules.value
                    }, null, 8, ["modelValue", "rules"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, { onClick: cancel }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: save,
                color: "primary",
                variant: "tonal",
                disabled: !valid.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.user ? "Actualizar" : "Crear"), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})